import { render, staticRenderFns } from "./Publicity.vue?vue&type=template&id=826187d2"
import script from "./Publicity.vue?vue&type=script&lang=js"
export * from "./Publicity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports